import { render, staticRenderFns } from "./modalEdicionStock.vue?vue&type=template&id=ec94f610&scoped=true&"
import script from "./modalEdicionStock.vue?vue&type=script&lang=js&"
export * from "./modalEdicionStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec94f610",
  null
  
)

export default component.exports